import { render, staticRenderFns } from "./AdminOfferingsChart.vue?vue&type=template&id=6c1f8f4b&"
import script from "./AdminOfferingsChart.vue?vue&type=script&lang=js&"
export * from "./AdminOfferingsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports